import { render, staticRenderFns } from "./ChatComp.vue?vue&type=template&id=0934c497&scoped=true"
import script from "./ChatComp.vue?vue&type=script&lang=js"
export * from "./ChatComp.vue?vue&type=script&lang=js"
import style0 from "./ChatComp.vue?vue&type=style&index=0&id=0934c497&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0934c497",
  null
  
)

export default component.exports